import React, {
	createContext,
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useState,
} from 'react';
import {
	FilterClients,
	FilterUser,
	GetAllUsers,
	GetClients,
	GetReports,
} from '../apis';
import { AuthContext } from '.';
import Cookies from 'js-cookie';
const SuperAdminContext = createContext();

const SuperAdminProvider = ({ children }) => {
	const { refreshToken } = useContext(AuthContext);
	const [clients, setClients] = useState([]);
	const [reports, setReports] = useState({});
	const [Allclients, setAllClients] = useState([]);
	const [users, setUsers] = useState([]);
	const [usersLoading, setUsersLoading] = useState(true);
	const [admins, setAdmins] = useState([]);
	const [adminsLoading, setAdminsLoading] = useState(true);
	const [clientsLoading, setClientsLoading] = useState(true);
	const [counter, setCounter] = useState(0);
	const accessToken = Cookies.get('access');
	const [search, setSearch] = useState('');

	const handleSearchText = useCallback(async e => {
		setInputSearchValue(e?.target?.value);
		const resp = await GetClients();
		let search = e?.target?.value;

		if (resp) {
			const filteredData = resp.data.results?.flatMap(item => {
				let p = item?.country ? item?.country.toLowerCase() : '';
				let q = item?.state ? item?.state.toLowerCase() : '';
				let r = item?.organization ? item?.organization.toLowerCase() : '';
				let a = p + q + r;
				let b = a.match(search);
				if (b != null) return [item];
				return [];
			});

			if (filteredData.length === 0) {
			}
			setClients(filteredData);
		}
	}, []);

	const handleUserSearchText = useCallback(async e => {
		setInputSearchValue(e?.target?.value);
		const resp = await GetAllUsers();
		let search = e?.target?.value;

		if (resp) {
			const filteredData = resp.data.users?.flatMap(item => {
				let p = item?.email ? item?.email.toLowerCase() : '';
				let q = item?.firstName ? item?.firstName.toLowerCase() : '';
				let r = item?.organization ? item?.organization.toLowerCase() : '';
				let s = item?.lastName ? item?.lastName.toLowerCase() : '';
				let a = p + q + r + s;
				let b = a.match(search ? search.toLowerCase() : '');
				if (b != null) return [item];
				return [];
			});

			if (filteredData.length === 0) {
			}
			setUsers(filteredData);
		}
	}, []);

	const handleAdminSearchText = useCallback(async e => {
		setInputSearchValue(e?.target?.value);
		const resp = await GetAllUsers();
		let search = e?.target?.value;

		if (resp) {
			const filteredData = resp.data.admins?.flatMap(item => {
				let p = item?.email ? item?.email.toLowerCase() : '';
				let q = item?.firstName ? item?.firstName.toLowerCase() : '';
				let r = item?.organization ? item?.organization.toLowerCase() : '';
				let s = item?.lastName ? item?.lastName.toLowerCase() : '';
				let a = p + q + r + s;
				let b = a.match(search ? search.toLowerCase() : '');
				if (b != null) return [item];
				return [];
			});

			if (filteredData.length === 0) {
			}
			setAdmins(filteredData);
		}
	}, []);

	const handleUserFilterText = useCallback(
		(clienId, is_active, user_type, searchText) => async () => {
			const resp = await FilterUser({
				organization: `${clienId}`,
				is_active: is_active,
				user_type: user_type,
			});
			if (resp?.data?.datalength === 0) {
			}
			if (searchText !== '') {
				const filteredData = resp?.data?.data?.flatMap(item => {
					let p = item?.email ? item?.email.toLowerCase() : '';
					let q = item?.firstName ? item?.firstName.toLowerCase() : '';
					let r = item?.organization ? item?.organization.toLowerCase() : '';
					let s = item?.lastName ? item?.lastName.toLowerCase() : '';
					let a = p + q + r + s;
					let b = a.match(searchText ? searchText.toLowerCase() : '');
					if (b != null) return [item];
					return [];
				});

				if (filteredData.length === 0) {
				}
				if (user_type === 'CLIENT_USER') {
					setUsers(filteredData);
				} else if (user_type === 'CLIENT_ADMIN') {
					setAdmins(filteredData);
				}
			} else {
				if (user_type === 'CLIENT_USER') {
					setUsers(resp?.data?.data);
				} else if (user_type === 'CLIENT_ADMIN') {
					setAdmins(resp?.data?.data);
				}
			}
		},
		[setUsers, setAdmins]
	);

	const handleClearFilterText = useCallback(
		async user_type => {
			const resp = await GetAllUsers();
			if (resp.status === 200 && user_type === 'CLIENT_USER') {
				setUsers(resp?.data?.users);
			} else if (resp.status === 200 && user_type === 'CLIENT_ADMIN') {
				setAdmins(resp?.data?.admins);
			}
		},
		[setUsers, setAdmins]
	);

	const handleClientFilterText = useCallback(
		(is_active, searchText) => async () => {
			const resp = await FilterClients({
				is_active: is_active,
			});
			if (resp?.data?.count !== 0) {
				if (searchText !== '') {
					const filteredData = resp.data.results?.flatMap(item => {
						let p = item?.country ? item?.country.toLowerCase() : '';
						let q = item?.state ? item?.state.toLowerCase() : '';
						let r = item?.organization ? item?.organization.toLowerCase() : '';
						let a = p + q + r;
						let b = a.match(searchText);
						if (b != null) return [item];
						return [];
					});

					if (filteredData.length === 0) {
					}
					setClients(filteredData);
				} else {
					setClients(resp.data.results);
				}
			}
		},
		[setClients]
	);

	const superAdminReportsFilter = useCallback(
		(startDate, endDate, clientId) => async () => {
			const resp = await GetReports(startDate, endDate, clientId);
			if (resp?.data?.count !== 0) {
				setReports(resp?.data);
			}
		},
		[setReports]
	);

	const handleClientClearFilterText = useCallback(async () => {
		// setInputSearchValue("")
		const resp = await GetClients();
		if (resp?.data?.count !== 0) {
			setClients(resp.data.results);
		}
	}, [setClients]);

	const fetchallusers = useCallback(async () => {
		const resp = await GetAllUsers();
		if (resp.status === 200) {
			setUsers(resp.data.users);
			setAdmins(resp.data.admins);
		}
		setUsersLoading(false);
		setAdminsLoading(false);
	}, []);

	const fetchclients = useCallback(async () => {
		const resp = await GetClients();
		if (resp.status === 200) {
			setClients(resp.data.results);
			setAllClients(resp.data.results);
		}
		setClientsLoading(false);
	}, []);

	useEffect(() => {
		if (refreshToken && accessToken) {
			fetchclients();
			fetchallusers();
			handleSearchText();
			handleUserSearchText();
			handleAdminSearchText();
			handleUserFilterText();
			handleClearFilterText();
			handleClientFilterText();
			superAdminReportsFilter();
			handleClientClearFilterText();
		}
	}, [
		refreshToken,
		counter,
		accessToken,
		handleSearchText,
		handleUserSearchText,
		handleAdminSearchText,
		handleUserFilterText,
		handleClearFilterText,
		fetchallusers,
		fetchclients,
		handleClientFilterText,
		superAdminReportsFilter,
		handleClientClearFilterText,
	]);

	const [InputSearchValue, setInputSearchValue] = useState('');

	const value = useMemo(
		() => ({
			clients,
			clientsLoading,
			counter,
			setCounter,
			setClients,
			setReports,
			Allclients,
			setAllClients,
			reports,
			users,
			setUsers,
			admins,
			setAdmins,
			usersLoading,
			adminsLoading,
			handleSearchText,
			handleUserSearchText,
			handleAdminSearchText,
			handleUserFilterText,
			handleClearFilterText,
			handleClientFilterText,
			superAdminReportsFilter,
			handleClientClearFilterText,
			fetchclients,
			fetchallusers,
			search,
			setSearch,
			InputSearchValue,
		}),
		[
			clients,
			clientsLoading,
			counter,
			setCounter,
			setClients,
			setReports,
			Allclients,
			setAllClients,
			users,
			reports,
			setUsers,
			admins,
			setAdmins,
			usersLoading,
			adminsLoading,
			handleSearchText,
			handleUserSearchText,
			handleAdminSearchText,
			handleUserFilterText,
			handleClearFilterText,
			handleClientFilterText,
			superAdminReportsFilter,
			handleClientClearFilterText,
			fetchclients,
			fetchallusers,
			search,
			setSearch,
			InputSearchValue,
		]
	);

	return (
		<SuperAdminContext.Provider value={value}>
			{children}
		</SuperAdminContext.Provider>
	);
};

export { SuperAdminContext, SuperAdminProvider };
